// src/app/services/utils/date-utils.ts
export interface ParsedDates {
  startDate: Date;
  endDate: Date;
}

function startOfDay(d: Date): Date {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

function isValid(d: Date): boolean {
  return !isNaN(d.getTime());
}


/**
 * Toma dos strings en formato "DD/MM/YYYY" y devuelve objetos Date.
 */
export function parseDates(start: string, end: string): ParsedDates {
  const [d1, m1, y1] = start.split('/');
  const [d2, m2, y2] = end.split('/');
  return {
    startDate: new Date(`${y1}-${m1}-${d1}`),
    endDate:   new Date(`${y2}-${m2}-${d2}`),
  };
}

/**
 * Valida que las fechas sean válidas y que end > start y start igual o mayor al día actual.
 */
export function areDatesValid(dates: ParsedDates, now: Date = new Date()): boolean {
  const start = startOfDay(dates.startDate);
  const end   = startOfDay(dates.endDate);
  const today = startOfDay(now);

  return isValid(start)
      && isValid(end)
      && end >= start          
      && start >= today;
}

/**
 * Devuelve número de días entre 2 fechas
 */
export function getNumberOfDaysBeetWeenStringDates(startDate: string, endDate: string): number {
    const MS_PER_DAY = 1000 * 60 * 60 * 24;
    const date = parseDates(startDate, endDate);
    const utcA = Date.UTC(date.startDate.getFullYear(), date.startDate.getMonth(), date.startDate.getDate());
    const utcB = Date.UTC(date.endDate.getFullYear(), date.endDate.getMonth(), date.endDate.getDate());
    return Math.floor((utcB - utcA) / MS_PER_DAY);
}